var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitalsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20703 21.645V17.395H3.95703V8.89502H8.20703V4.64502H16.707V8.89502H20.957V17.395H16.707V21.645H8.20703ZM5.65703 12.295H9.90703C10.0487 12.295 10.1833 12.3304 10.3108 12.4013C10.4383 12.4721 10.5374 12.5642 10.6083 12.6775L11.352 13.7825L12.4995 10.34C12.5562 10.17 12.6589 10.0284 12.8077 9.91502C12.9564 9.80169 13.1229 9.74502 13.307 9.74502C13.4487 9.74502 13.5833 9.78044 13.7108 9.85127C13.8383 9.9221 13.9374 10.0142 14.0083 10.1275L15.4533 12.295H19.257V10.595H15.007V6.34502H9.90703V10.595H5.65703V12.295ZM9.90703 19.945H15.007V15.695H19.257V13.995H15.007C14.8654 13.995 14.7308 13.9596 14.6033 13.8888C14.4758 13.8179 14.3695 13.7259 14.2845 13.6125L13.562 12.5075L12.4145 15.95C12.3579 16.12 12.2516 16.2617 12.0958 16.375C11.9399 16.4884 11.7699 16.545 11.5858 16.545C11.4441 16.545 11.3095 16.5096 11.182 16.4388C11.0545 16.3679 10.9554 16.2759 10.8845 16.1625L9.43953 13.995H5.65703V15.695H9.90703V19.945Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsBlack);
export default __webpack_public_path__ + "static/media/vitalsBlack.dbb42acc2326b403560da01e0968b0e8.svg";
export { ForwardRef as ReactComponent };